import { Table, TableBody, TablePagination } from "@mui/material";
import { handleChangePage, handleChangeRowsPerPage } from "../../../../SharedComponents/utils/helpers/tableHelpers";
import OfferTableHeadHomePage from "../TableHeads/OfferTableHeadHomePage";
import OfferTableRowHomePage from "../TableRows/OfferTableRowHomePage";


const OfferTableHomePage = ({
    count,
    fetchedActiveCarOffers,
    rowsPerPage,
    setRowsPerPage,
    page,
    setPage,
    onRowSelect,



}) => {

    return (

        <div style={styles.tablePaddingDiv}>
            <div style={styles.tableBorderDiv}>
                <Table sx={{ minWidth: 900, width: "100%" }}>
                    <OfferTableHeadHomePage />

                    <TableBody>
                        {fetchedActiveCarOffers.map((offer) => (
                            <OfferTableRowHomePage
                                key={offer.part_offer_id}
                                carOffers={offer}
                                onSelect={() => onRowSelect(offer.part_offer_id)}
                            />
                        ))}
                    </TableBody>

                </Table>

                <TablePagination
                    rowsPerPageOptions={[15, 25, 50]}
                    component="div"
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(event, newPage) => {
                        handleChangePage(event, newPage, setPage);
                    }}
                    onRowsPerPageChange={(event) => {
                        const newRowsPerPage = parseInt(event.target.value, 10);
                        handleChangeRowsPerPage(event, setRowsPerPage, setPage);
                    }}
                />

            </div>
        </div>
    );
};

export default OfferTableHomePage;

const styles = {
    tablePaddingDiv: {
        paddingInline: 30,
    },
    tableBorderDiv: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        width: '100%',
        overflowX: 'auto',
    }
};
